import { ModuleBase, HeadingTag, Media, Link } from '@/components';
import classNames from 'classnames';

const RichTextWithMediaModule = ({ data }) => {
  const { headingTitle, preHeading, media, primaryCTA, secondaryCTA, mediaAlignment } = data;

  return (
    <ModuleBase data={data} className="font-montserrat">
      <div className="color-from-bg container">
        <div className="flex flex-col">
          {preHeading && <p className="text-subheading my-4 text-base uppercase text-grey3">{preHeading}</p>}
          {headingTitle && <HeadingTag data={headingTitle} className={'text-' + data.headingTitle.htag}></HeadingTag>}
        </div>
        <div
          className={classNames(
            'mt-16 flex w-full flex-col sm:mt-20 lg:flex-row lg:gap-32',
            mediaAlignment === 'Right' ? 'lg:flex-row-reverse' : '',
          )}
        >
          <div className="mx-auto w-full max-w-[392px] lg:w-[27.22%]">
            <figure className="aspect-3/4">
              {media && (
                <Media
                  media={media}
                  widths={{ xs: 392, sm: 392, md: 392, lg: 392, xl: 392, xxl: 392 }}
                  heights={{ xs: 523, sm: 523, md: 523, lg: 523, xl: 523, xxl: 523 }}
                  className="h-full w-full object-cover"
                />
              )}
            </figure>
            {media?.description && (
              <figcaption className="text-caption mt-4 rtl:text-right">{media.description}</figcaption>
            )}
          </div>

          <div className="mt-16 w-full sm:mt-20 lg:mt-0 lg:w-[72.88%]">
            <div className="richtext-content mb-10" dangerouslySetInnerHTML={{ __html: data.content }} />
            <div className="flex flex-col items-start">
              {primaryCTA && <Link className="btn primary" link={primaryCTA} />}
              {secondaryCTA && <Link className="btn secondary last:mt-4 only:mt-0" link={secondaryCTA} />}
            </div>
          </div>
        </div>
      </div>
    </ModuleBase>
  );
};
export default RichTextWithMediaModule;
